import { withTheming, getFocusStyles } from '@doordash/design-language';
import styled from 'styled-components';

var PasswordToggle = withTheming(styled.button.attrs(function () {
  return {
    type: 'button'
  };
}).withConfig({
  displayName: "Password__PasswordToggle",
  componentId: "sc-1nm150n-0"
})(["cursor:pointer;appearance:none;padding:0;border:none;background:none;&&:focus{", ";}"], function (props) {
  return getFocusStyles({
    theme: props.theme
  });
}));

export { PasswordToggle };
